module.exports = __webpack_public_path__ + "img/30.6c7d09fd.svg";